export const roadC1 = [
     {
        id: 2,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Present Simple ",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [

         { titulo:"Present Simple Grammar Guide ",descripcion:"This comprehensive guide will teach you all the uses, rules, and structures",url3: "https://youtu.be/u7pyidVI8Rw"},
         { titulo:"Present Simple ",descripcion:"Aprende a usar el present simple en diferentes contextos ",url:"https://drive.google.com/file/d/1rwleyKN1vwRdZLJuHZXbIB3t88hevTl3/view?usp=sharing",url3: "https://youtu.be/hY2sLzte-HQ?si=hKDYW1znThnc-JbX"},
        

          
        ],
    },
     {
        id: 3,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Present Progressive ",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [

         { titulo:"Present Progressive",descripcion:"Aprende a usar el present progressive en diferentes contextos ",url:"https://drive.google.com/file/d/1Rqx1bzuRRJbjHZnH_iutOhx7oIzQoeut/view?usp=sharing",url3: "https://youtu.be/movGMBm7zbk"},
        
        ],
    },
    {
        id: 4,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Present Simple vs Present Progressive ",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [
         { titulo:"Stative & Dynamic Verbs",descripcion:"Completa los niveles para dominar estos tiempos ",url: "https://drive.google.com/file/d/1FG5tjBDMaCCaFOBDxZ039CgdcFevvJcc/view?usp=sharing",url3:"https://youtu.be/R07Mg2YreIg"},

         { titulo:"Present Simple vs Present Progressive ",descripcion:"Completa los niveles para dominar estos tiempos ",url5: "https://learnibox.vercel.app/presentsimpleprogressive"},
        
        ],
    },
    {
        id: 5,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Past Tenses",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [
          {  titulo:"English Verb Tenses | Complete Guide with Uses & Examples ", url: "https://drive.google.com/file/d/1Mxxxxi0x13HrO5EvSECowdaRF0Vg9fIK/view?usp=sharing",url3:"https://youtu.be/-Wp-i77JHM8"},

         {  titulo:"Past Simple", url: "https://drive.google.com/file/d/1aAwupScFNRFoNArgtm5f_3k5a0Eyfztt/view?usp=sharing",url3:"https://youtu.be/cZrMl1bTons?si=QOI7p1xaVQV3Bp_B"},
         { titulo: "Past Progressive ",url: "https://drive.google.com/file/d/18QxoihCFpTI0wyWQgr50OZtCdWWNVwqw/view?usp=sharing", },
         { titulo:"Past Simple vs Past Progressive ",descripcion:"Completa los niveles para dominar estos tiempos ",url5: "https://learnibox.vercel.app/pastsimpleprogressive"},
     
        ],
    },
     {
        id: 6,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Present Perfect Tenses",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [
          {  titulo:"English Verb Tenses | Complete Guide with Uses & Examples ", url: "https://drive.google.com/file/d/1Mxxxxi0x13HrO5EvSECowdaRF0Vg9fIK/view?usp=sharing",url3:"https://youtu.be/-Wp-i77JHM8"},
        
         {  titulo:"Present Perfect", url: "https://drive.google.com/file/d/1Vgvz7c7QrW_FMs5AN70TscKd_z6nh0Pv/view?usp=sharing",url3:"https://youtu.be/FQGoT7jGekQ?si=hvw06VmTNgbysrIT"},
         { titulo:"Past Simple vs Present Perfect",descripcion:"Completa los niveles para dominar estos tiempos ",url5: "https://learnibox.vercel.app/pastsimpleperfect"},
         
        {  titulo:" Present Perfect Progressive", url: "https://drive.google.com/file/d/1XKmee6Sthrl756nWgoifeDb0D6jrob1e/view?usp=sharing"},
            {  titulo:" Perfect Simple vs  Perfect Progressive", url: "https://drive.google.com/file/d/1IGrGmE7B44z6YCVSVVSFjWS10CV_mjdC/view?usp=sharing"},

            { titulo: "✍ Past Simple and Present Perfect (Simple and Progressive) ",url: "https://drive.google.com/file/d/10efo7YOPNaICX_E6_DQJsYZ5ctxm2xYQ/view?usp=sharing", },    
             { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1D0VK7vPjtlAMOc8WqxQUQn62_F3-uJsa/view?usp=sharing", },            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1GWFlQ8RvPK7qb3S8HLBhKTlBONeogy0H/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1jgcxBuSKBZ6LdIQbWXL3_4lJDv4D8QVa/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1jvFbc4GPFUHXIgx0gmbgslQQz7KmIMG0/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1iCSWPTOFu1vGbkEaW6xSPh-Z_-koKr3V/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1uik-f0MFXujPMnbgmOiCIegxSmWAI5qI/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1CyruZuJFKhWpzmNmFQ9H9oigRjqgY0ui/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1i-A68Tl92LNR87MyIWPPTEceTrIlU_hw/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/11Jj4BydUErvqumFiFy5goX5pGQkZq9HY/view?usp=sharing", },
              { titulo: "Future Simple ",url: "https://drive.google.com/file/d/1qv1NHearXkAYne1cH9N0MBc4ikdNtAV-/view?usp=sharing",url2:"https://youtu.be/uaeFf4lMksI?si=uu8wSw6G_svG3v8T" },    

            { titulo: "✍ Ways of Expressing Future Tense ",url: "https://drive.google.com/file/d/1J6r3JFYzr-U4CzRQihyMcl6uB2Ms7bu0/view?usp=sharing", },    
            { titulo: "✍  Future Tenses ",url: "https://drive.google.com/file/d/1uQEVuavBgrytYsOTlD3dAg8qZDCtZEa_/view?usp=sharing", },
        ],
    },
         {
        id: 7,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Future",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [
          {  titulo:"English Verb Tenses | Complete Guide with Uses & Examples ", url: "https://drive.google.com/file/d/1Mxxxxi0x13HrO5EvSECowdaRF0Vg9fIK/view?usp=sharing",url3:"https://youtu.be/-Wp-i77JHM8"},
        
        
              { titulo: "Future Simple ",url: "https://drive.google.com/file/d/1qv1NHearXkAYne1cH9N0MBc4ikdNtAV-/view?usp=sharing",url2:"https://youtu.be/uaeFf4lMksI?si=uu8wSw6G_svG3v8T" },    

            { titulo: "✍ Ways of Expressing Future Tense ",url: "https://drive.google.com/file/d/1J6r3JFYzr-U4CzRQihyMcl6uB2Ms7bu0/view?usp=sharing", },    
            { titulo: "✍  Future Tenses ",url: "https://drive.google.com/file/d/1uQEVuavBgrytYsOTlD3dAg8qZDCtZEa_/view?usp=sharing", },
        ],
    },
      
     
      {
        id: 8,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Essential Grammar ",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [
         { titulo:"As far as, Until, Up to ",descripcion:"diferencias ",url: "https://drive.google.com/file/d/16CJjTB0ZPDvQuzpOLMR22R0jK7QCe-c3/view?usp=sharing",url3:"https://youtu.be/pa2m8Ja3qBo?si=WicK2xiUfjNCrGZm"},
         { titulo:"Doubt that vs Doubt if",descripcion:"diferencias ",url: "https://drive.google.com/file/d/1qEgnOfM7BoFG1lmMu_xWgNbRlwBTt9X2/view?usp=sharing",url3:"https://youtu.be/7zype2HxL44?si=GBH3KrxdfzI5bCdY"},
            { titulo:"Enough and Too ",url: "https://drive.google.com/file/d/1Tcadp5eOdfsHOlCwJWs0iNuphHQO4gYA/view?usp=sharing",url3:"https://youtu.be/Gie_3C6BIeo"},
            { titulo:"The fact that  ",url: "https://drive.google.com/file/d/1FSd3Vt3C71C0kujDoy4egxFDy8_ZugZv/view?usp=sharing",url3:"https://youtu.be/fXiGq7IuBec"},
            { titulo:"Raise vs Rise..",url: "https://drive.google.com/file/d/1K57hHa19p8k36dka59AM7pyFERFxnap2/view?usp=sharing", url3:"https://youtu.be/iCq1HNpx5aA"},
            { titulo:"in the suburbs vs on the outskirts",url: "https://drive.google.com/file/d/1JMop9SCD1WVrMeQiXTFRD0IcsBqD-vjn/view?usp=sharing",url3:"https://youtu.be/4r4Fa9Zt1FI"},
            { titulo:"Time vs Moment",url: "https://drive.google.com/file/d/1DLFl-bn78Abyr-UQYLh9LN2J45t9UO8Q/view?usp=sharing",url3:"https://youtu.be/IHYu3WXR7yg"},

            { titulo:"Make the most/ the best, Get the better ",url: "https://drive.google.com/file/d/1pQvtcWZpqNw-8sWDfAST6b0DfqpubGz1/view?usp=sharing",url3:"https://youtu.be/GgCg9ZdY1TY"},
           { titulo:"Cleft Sentences",url: "https://drive.google.com/file/d/13-JhSbUYrCntdTi5t097wDYyeUmJH-g1/view?usp=sharing",url3:"https://youtu.be/PKr7p6KBvp4"},





           { titulo:"El Subjuntivo Presente en Inglés",url: "https://drive.google.com/file/d/1mOgCdm3FRZPrVcXErch-VVbfPLkjAyyh/view?usp=sharing",url4:"https://youtu.be/NnAJ2YzwBb0"},

           { titulo:"La Estructura “Need + Verb-ing",url: "https://drive.google.com/file/d/1nYiG9kFlC6eKq3bdZeP7NXblSXxrAc0-/view?usp=sharing",url4:"https://youtu.be/1mvTxoT3F4E"},


           { titulo:"El Presente Continuo para Hablar del Futuro en Inglés",url: "https://drive.google.com/file/d/1ikDyGzOeLljhVhpp_QzaO1B7IswUG0FD/view?usp=sharing",url4:"https://youtu.be/UnLCzBWOVv8"},

           { titulo:"Mastering “Would” vs “Used To” en Inglés: Diferencias",url: "https://drive.google.com/file/d/1V037fa6ebo2IYSnfigdESc3ba44I0aiF/view?usp=sharing",url4:"https://youtu.be/7ueRrDyJ7To"},
           { titulo:"La Construcción It is nice of you ",url: "https://drive.google.com/file/d/13cUcLcuL3RUeuLo_Z2AFhJRoLsXp5shM/view?usp=sharing",url4:"https://youtu.be/2pRAIpj3pLo"},

           { titulo:"If I Had My Way” en Inglés” ",url: "https://drive.google.com/file/d/1dYAFj4142yAIad_hJsswoEJ6ahvWXF4H/view?usp=sharing",url4:"https://youtu.be/ANqiXYG1baM"},
           { titulo:"La Estructura The + Adjective en Inglés ",url: "https://drive.google.com/file/d/1i5J--IifJlphyKHkhcbbcgl9WmQvCuuK/view?usp=sharing",url4:"https://youtu.be/jInF0rW2gIw"},

           { titulo:"Better Yet y Worse Yet/Still en Inglés ",url: "https://drive.google.com/file/d/1Alu1hNgWzPj0S9fzz-L7sTcX8yU_Cojh/view?usp=sharing",url4:"https://youtu.be/kajRjh9Slvg"},


           { titulo:"Domina “Have/Be Yet To” en Inglés Forma",url: "https://drive.google.com/file/d/183t2PttV6cF2jFuqGcodJO1jwQ393noM/view?usp=sharing",url4:"https://youtu.be/WnObWryxyyY"},


           { titulo:"Mastering Passive Reporting Structures en Inglés",url: "https://drive.google.com/file/d/1NiMXPFhxTyeF7aoXabdYJbqFblrqyskV/view?usp=sharing",url4:"https://youtu.be/cAz5VLx1BLE"},

           { titulo:"Inversion with HAD: La Guía Definitiva del 3rd Conditional ",url: "https://drive.google.com/file/d/1i_zI_uOdWTPnuDKzoDpYMwiCk3hKRsix/view?usp=sharing",url4:"https://youtu.be/_yAlO9IK1sM"},
            { titulo:"Inversion with WERE: La Guía Avanzada del Second Conditional",url: "https://drive.google.com/file/d/1cqkgJLR3Bni4pRVLiB3LaRtns37Da1BQ/view?usp=sharing",url4:"https://youtu.be/8_bxl9ihAm4"},

             { titulo:"Should Inversion in the First Conditional",url: "https://drive.google.com/file/d/1ZuB5KhOsQh2jFGFVDnYFAgHBsLKY4PV5/view?usp=sharing",url4:"https://youtu.be/tIEq8ShFlzk"},

           { titulo:"Advanced Grammar: Be Due / Be Sure / Be Bound / Be Set To — Alternativas Formales a “Going To",url: "https://drive.google.com/file/d/1Dyk3p1T0ZKRsI52T4tqInqJs627E-ikn/view?usp=sharing",url4:"https://youtu.be/mZ1vl4mzo9Y"},

                      { titulo:"Very as an Adjective",url: "https://drive.google.com/file/d/1FU7MqlXEY4lbZW5k8iufMWU5X6Ypxcdq/view?usp=sharing",url4:"https://youtu.be/V7e_4fEg4D0"},

           { titulo:"Mastering “But For” in English Conditionals",url: "https://drive.google.com/file/d/1nUeXnweowSPom-LsWVErL6BDNKsrhlgv/view?usp=sharing",url4:"https://youtu.be/gqyupeKg04s"},

           { titulo:"Mastering “Be To” in If-Clauses",url: "https://drive.google.com/file/d/1DNHTxpMkIskorC7NoyYI8PqDbw2P3wx7/view?usp=sharing",url4:"https://youtu.be/6VQ3iCbs778"},

           { titulo:"Mastering Inversion with “So”",url: "https://drive.google.com/file/d/1PqObqHkpQUXhRfGyBuFEZ8NZuNLRHap4/view?usp=sharing",url4:"https://youtu.be/bUilFTUV-Aw"},

           { titulo:"It’s High Time”: La Guía Definitiva",url: "https://drive.google.com/file/d/1XLAoY5-uKkx8HPQ4KvgApRIMHLyo4Ufi/view?usp=sharing",url4:"https://youtu.be/MfLnFi4L_W8"},

           { titulo:"La Estructura “The More, The More” en Inglés",url: "https://drive.google.com/file/d/1JGIun4VCWyHvcoAqbCaR6LqYpaAdQNOJ/view?usp=sharing",url4:"https://youtu.be/efMg1CIXh64"},

           { titulo:"Usar “May” para Expresar Deseos en Inglés",url: "https://drive.google.com/file/d/1dk3Z8b6Ppz0TWb1vG4tNLNIrIpxNSPqs/view?usp=sharing",url4:"https://youtu.be/9z9waww_c08"},

           

                 { titulo:"Especially vs. Specially: La Guía Definitiva ",url: "https://drive.google.com/file/d/1Nlfd7f8tLd1HJYzKOFAZ1KPhych-xhEn/view?usp=sharing",url4:"https://youtu.be/o6KlDImyCRI"},
                      { titulo:" If vs. Whether: La Guía Definitiva ",url: "https://drive.google.com/file/d/1iU1BzIraEk6xzj99bOxVoEdOyn05YNev/view?usp=sharing",url4:"https://youtu.be/COsaD9QaqlE"},

                             


            { titulo:"Challenges",descripcion:"Completa todos  los niveles",url5: "https://learnibox.vercel.app/essentialgrammar"},
        ],
    },
        {
        id: 12,
        thumbnail:"https://i.ibb.co/RTGW1WxL/newback.png",

        title: "Cambridge Simulator ",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: " ",
        enlaces: [
            { titulo:"Multiple Choice Cloze Simulation I ",descripcion:"The first part of the Use of English paper in the B2 First Examination is multiple choice cloze where students have to choose the correct word from four similar given words.",url4:"https://learnibox.vercel.app/uoepart1"},

            { titulo:"Multiple Choice Cloze Simulation II ",descripcion:"The first part of the Use of English paper in the B2 First Examination is multiple choice cloze where students have to choose the correct word from four similar given words.",url4:"https://learnibox.vercel.app/multiplechoice"},
             { titulo:"Open Cloze",descripcion:"The second part of the Use of English paper in the B2 First Examination is open cloze, in which students use one word to fill each space in a short text. The required words are usually grammatical, such as pronouns, articles, prepositions, auxiliary verbs and so on.",url4:"https://learnibox.vercel.app/uoepart2"},


            
          

             { titulo:"Real exam Simulation 01 ",url3: "https://learnibox.vercel.app/simulator"},

        

            { titulo: "Word Formation",descripcion:"The third part of the Use of English paper in the B2 First Examination is word formation where students use a root such as 'able' and create an appropriate word (disable, unable, ability) to fill the gap in a text.",url: "https://drive.google.com/file/d/1FoMiuTrYJHxJYyBsbBrqvs10Kb8cYf2T/view?usp=sharing",url7:"https://drive.google.com/file/d/1cy_Ap7DUYRZWyCVjPoAYy3njDBlrmXm_/view?usp=sharing",url8:"http://learnibox.vercel.app/tc" },    
            { titulo: "✍ WF002 - Prefixes and Negative Meanings ",url: "https://drive.google.com/file/d/1NI-L5UBxQ5gFeRac6oVhMXD_T-5YCjiv/view?usp=sharing",url3:"https://drive.google.com/drive/folders/1T8c6lyVyjh6a2e2MM4M5jeDN8PRcARnR?usp=sharing" },    
            { titulo: "✍ WF003 - Crossword - Word Formation ",url: "https://drive.google.com/file/d/194QnF1Gc-wIRpiWAOtqWy-D8B78coaSL/view?usp=sharing", },    
            { titulo: "✍ WF019 - Word Formation - Nouns, Verbs, Adjectives ",url: "https://drive.google.com/file/d/18krxCjRSmgc3wfWPtGK2qggwq0lUlfnW/view?usp=sharing", },    
            { titulo: "✍ WF020 - Word Formation - Nouns, Verbs, Adjectives ",url: "https://drive.google.com/file/d/18J49WKoMt8jXjiKAcxrFnaqTykF-0QHw/view?usp=sharing", },    
            { titulo: "✍ WF021 - Word Formation - Nouns, Verbs, Adjectives ",url: "https://drive.google.com/file/d/17L45VWvsHTY1ToaELcaEXaIpT8bgSKRB/view?usp=sharing", },    

           
            {  titulo:"📝 Examen 01  ",url: "https://drive.google.com/file/d/1Sk4W7Ax3Ao9ZqGR4sVY4IFik3Jq6BQ_N/view?usp=sharing"},
            {  titulo:"📝 Examen 01 Solucionario ",url: "https://drive.google.com/file/d/13NnSnUDD8m95_AryEwZ5hMnfdxKYrQKV/view?usp=sharing"},

            {  titulo:"📝[Test 01 ] FCE + SOLUCIONARIO ",url: "https://drive.google.com/file/d/1sz-WQ4yS7S4GMUgZHXz6uqTD0oA5pJ5M/view?usp=sharing"},
            {  titulo:"📝[Test 02 ] FCE + SOLUCIONARIO ",url: "https://drive.google.com/file/d/192v80IEi93ZaiRY1-NkY5h-qk2XyA6O_/view?usp=sharing"},

            {  titulo:"📝[Test] Key Word Transformation 01 ",url: "https://drive.google.com/file/d/1Ng-AL8s5uNqA4AeVSa9x-4ySFH_dqsKU/view?usp=sharing"},
            {  titulo:"📝🔑[Test Answer Key] Key Word Transformation 01 ",url: "https://docs.google.com/presentation/d/1_lR0KYShBJeyFw-ZOuMIEwwLyIdLb2s591vIc4pAIsU/edit?usp=sharing"},

            {  titulo:"📝[Test] Multiple Choice Cloze 01 ",url: "https://drive.google.com/file/d/1Y-2SMBjU5xafwMwdH2VB8NJMWwKQMB5-/view?usp=sharing"},
            {  titulo:"📝🔑[Test Answer Key] Multiple Choice Cloze 01",url: "https://docs.google.com/presentation/d/1koBZiWPQtnw6GgFEfWpNORHWd0TvwYYnRbr661Ahh94/edit?usp=sharing"},

            {  titulo:"📝[Test] Open Cloze 01 ",url: "https://drive.google.com/file/d/1yRCvF2OW3VJfHSqREMmUb4RzAXK6Hfg1/view?usp=sharing"},
            {  titulo:"📝[Test] Word Formation 01 ",url: "https://drive.google.com/file/d/1SOnsELpD7Y4laW2l--YpXeKcut6QM8ZA/view?usp=sharing"},
            {  titulo:"🗣[Test] Speaking Section 01 ",url: "https://drive.google.com/file/d/1tG0g65N35lS8hp1r4LRPDSkynxug5C51/view?usp=sharing"},

        ],
    },
    {
        id: 2,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Essential Grammar ",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [
         { titulo:"As far as, Until, Up to ",descripcion:"diferencias ",url: "https://drive.google.com/file/d/16CJjTB0ZPDvQuzpOLMR22R0jK7QCe-c3/view?usp=sharing",url3:"https://youtu.be/pa2m8Ja3qBo?si=WicK2xiUfjNCrGZm"},
         { titulo:"Doubt that vs Doubt if",descripcion:"diferencias ",url: "https://drive.google.com/file/d/1qEgnOfM7BoFG1lmMu_xWgNbRlwBTt9X2/view?usp=sharing",url3:"https://youtu.be/7zype2HxL44?si=GBH3KrxdfzI5bCdY"},
            { titulo:"Enough and Too ",url: "https://drive.google.com/file/d/1Tcadp5eOdfsHOlCwJWs0iNuphHQO4gYA/view?usp=sharing",url3:"https://youtu.be/Gie_3C6BIeo"},
            { titulo:"The fact that  ",url: "https://drive.google.com/file/d/1FSd3Vt3C71C0kujDoy4egxFDy8_ZugZv/view?usp=sharing",url3:"https://youtu.be/fXiGq7IuBec"},
            { titulo:"Raise vs Rise..",url: "https://drive.google.com/file/d/1K57hHa19p8k36dka59AM7pyFERFxnap2/view?usp=sharing", url3:"https://youtu.be/iCq1HNpx5aA"},
            { titulo:"in the suburbs vs on the outskirts",url: "https://drive.google.com/file/d/1JMop9SCD1WVrMeQiXTFRD0IcsBqD-vjn/view?usp=sharing",url3:"https://youtu.be/4r4Fa9Zt1FI"},
            { titulo:"Time vs Moment",url: "https://drive.google.com/file/d/1DLFl-bn78Abyr-UQYLh9LN2J45t9UO8Q/view?usp=sharing",url3:"https://youtu.be/IHYu3WXR7yg"},

            { titulo:"Make the most/ the best, Get the better ",url: "https://drive.google.com/file/d/1pQvtcWZpqNw-8sWDfAST6b0DfqpubGz1/view?usp=sharing",url3:"https://youtu.be/GgCg9ZdY1TY"},
           { titulo:"Cleft Sentences",url: "https://drive.google.com/file/d/13-JhSbUYrCntdTi5t097wDYyeUmJH-g1/view?usp=sharing",url3:"https://youtu.be/PKr7p6KBvp4"},

            { titulo:"Challenges",descripcion:"Completa todos  los niveles",url5: "https://learnibox.vercel.app/essentialgrammar"},
        ],
    },
     
    {
        id: 1,
        thumbnail:"https://i.ibb.co/9kqY7G0n/DALL-E-2025-03-23-15-06-19-Epic-widescreen-wallpaper-showing-a-group-of-students-as-heroic-warriors.webp",
        reconpensa: "https://i.ibb.co/jkkK0wXX/RECONPENSAPRESENTSIMPLE.webp",
        reconpensaDescripcion: "La Espada Legendaria ‘Routine & Facts’ resplandece con un aura mística, irradiando la esencia misma del Present Simple. Su hoja afilada y resplandeciente está grabada con inscripciones que representan la estructura inquebrantable de este tiempo verbal ⚔️✨",
        title: "Real English World 01",
        subtitle: "B2/C1",
        color: "#8F2BBC",
        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Aprende a hablar como un hablante nativo enfocándote en la pronunciación, entonación y expresiones idiomáticas para mejorar tu fluidez y naturalidad al hablar.",
        enlaces: [

            { titulo:"Make it so that",descripcion:"sds",url: "https://drive.google.com/file/d/1Hm_asZSbjMBSRXmYsgdthDikC74-07gk/view?usp=sharing",url3:"https://drive.google.com/file/d/154879HFSZD2dS4qF1BGMc9M7hUz2cVkQ/view?usp=sharing"},

            { titulo:"Might",descripcion:"criticism / suggestions",codigo:"sss",url: "https://drive.google.com/file/d/1IYxzlKp0wyJji-pJfEgqJxRKeh7HF4iK/view?usp=sharing",url3:"https://drive.google.com/file/d/1S08Nlr5g0wLFD6A6ueY8s5qSbsHIRHSW/view?usp=sharing"},

            { titulo:"Much to someone's ../To someone's.. ",url: "https://drive.google.com/file/d/1WepNF28NcFBzr7x9DJlPwipJLXoe3yYU/view?usp=sharing"},

            { titulo:"📚[Slide] Muse, Amuse , Bemuse  ",url: "https://drive.google.com/file/d/143LZdKC50ltIpSvzXLvGGLKBSOgN4L9d/view?usp=sharing"},

            { titulo:"📚[Slide] Propose ,Recommend,Suggest ",url: "https://drive.google.com/file/d/1lIqneQZjM3aJ6GrbREhkPL1GfNNh6IyR/view?usp=sharing"},


        ],
    },
   
   
   {
        id: 0,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Present Simple & Progressive",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
           
            { titulo:"Present Simple ",descripcion:"Aprende a usar el present simple en diferentes contextos ",url:"https://drive.google.com/file/d/1rwleyKN1vwRdZLJuHZXbIB3t88hevTl3/view?usp=sharing",url2: "https://youtu.be/b5KxYRP2I5s"},
            { titulo:"Present Progressive",descripcion:"Aprende a usar el present progressive en diferentes contextos ",url:"https://drive.google.com/file/d/1Rqx1bzuRRJbjHZnH_iutOhx7oIzQoeut/view?usp=sharing",url2: "https://youtu.be/Nnu6JOaenf0"},
            { titulo:"Test Center App",descripcion:"Desafio de tiempo Present simple y progressive ",url4: "https://learnibox.vercel.app/presentsimpleprogressive"},

            { titulo:"Usual",descripcion:"Aprende los diferentes usos del usual",url: "https://drive.google.com/file/d/1Iru4Ttn7yf9vwOiUU8XjC6MCB9DPMHA8/view?usp=sharing",url2:"https://youtu.be/OSRAYauWH-I",url3:"https://drive.google.com/file/d/1sugjoNOr6dwEHogTwcKeYHUVbebEBbpX/view?usp=sharing"},
            { titulo:"Usually",url: "https://drive.google.com/file/d/1IPWIh1B7oYwV4aPRJJKnM-gpZICitsX_/view?usp=sharing",url2:"https://www.youtube.com/watch?v=nYxi8UCraJI&ab_channel=MyEnglishBro"},
            { titulo:"I think not vs I don't think so. ",url: "https://drive.google.com/file/d/15nnCB3JJRtH1fqqx5TypEptgoRbo5q-P/view?usp=sharing"},
            { titulo:"Enough and Too ",url: "https://drive.google.com/file/d/1Tcadp5eOdfsHOlCwJWs0iNuphHQO4gYA/view?usp=sharing"},

            {  titulo:"Battle Code ",descripcion:"Las respuestas de cada pregunta son el código del siguiente nivel",url:"https://drive.google.com/file/d/19bs04pZ2WROkgtnCaKSEXxp4hB_Fk_qa/view?usp=sharing"},

        ],
    },
 
    {
        id: 12,
        thumbnail:
            "https://i.ibb.co/f4YQsS1/B2-FIRST-11.png",
        title: "Essential Grammar ",
        subtitle: "B2/C1",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
            { "titulo": "[🖥️Class] Need + ing", "url": "https://www.youtube.com/watch?v=TwRQIGq2Uw0&ab_channel=MyEnglishBro" },
            { titulo:"📚[Slide] Extent - Phrases",url: "https://drive.google.com/file/d/1RNL8yvP8ciMWWd_vnp0hIsFfUpuANjEe/view?usp=sharing",url3:"https://drive.google.com/file/d/1Drm5SAw6foxSrI7xHkUEI4sfdYl58_ZY/view?usp=sharing"},
            { titulo:"📚[Slide] Substitution with 'Do so'  ",url: "https://drive.google.com/file/d/1cDQYA8CIBaBKuYwBlERsFkKxtMLa2CbC/view?usp=sharing"},
            { titulo:"📚[Slide] If meaning although   ",url: "https://drive.google.com/file/d/1HchwZN2R5mEOoF2Ju0-Hpk_Oe4WFe1Rd/view?usp=sharing"},

            { titulo:"📚 For meaning because ",url: "https://drive.google.com/file/d/1p3vDChnpQWHcwZ8FbJ0S6TzoBgeWHe5V/view?usp=sharing"},
            { titulo:"📚 Dangling Modifiers  ",url: "https://drive.google.com/file/d/1-MCDQdx5K_v6mEL7dgjh6TU4rTdfFVSN/view?usp=sharing"},
            { titulo:"📚[Slide] Doing too much - phrases ",url: "https://drive.google.com/file/d/1MXfUisuFRIhKqnotZue3pU9ZibXR-oRu/view?usp=sharing"},
            { titulo:"📚[Slide] Emphatic Pronouns ",url: "https://drive.google.com/file/d/17TbrOkcSgLeyAUSK3bCw1MhrPPD2wWOF/view?usp=sharing"},
            { titulo:"📚[Slide] Phrasal Prepositional Verbs Three-Word Phrasal Verbs  ",url: "https://drive.google.com/file/d/1Nl6kqqUhRt8kr5Kz6DSi5SnAgi29EaPm/view?usp=sharing"},
            { titulo:"📚[Slide] Phrasal Prepositional Verbs Three-Word Phrasal Verbs II ",url: "https://drive.google.com/file/d/139_mgdt8BqGNHp-9CXLFdmFYcnICZr2X/view?usp=sharing"},

            { titulo:"📚[Slide] Popular English Proverbs  ",url: "https://drive.google.com/file/d/1A8KPhIU9Txfi6_BVKpQYcIN6QtKvdu4v/view?usp=sharing"},
            { titulo:"📚[Slide] Hyphenated Compound verbs in English  ",url: "https://drive.google.com/file/d/132D6JBpECMY_gbwPBVvOl4f2k3nWs6G5/view?usp=sharing"},
            { titulo:"📚[Slide] Adding extra information  ",url: "https://drive.google.com/file/d/1d4ekX50tF7DulMtfp1sKhhWrg59TqNWq/view?usp=sharing"},
            { titulo:"📚[Slide] Advanced Comparatives  ",url: "https://drive.google.com/file/d/1kFTnMfMalxHz65aOTpDBn2KbPTmv6BPp/view?usp=sharing"},
            { titulo:"📚[Slide] Advanced Comparatives 2  ",url: "https://drive.google.com/file/d/1k-Lc6dy-aPFwoUYuNHJ_YzAWDxjttSdE/view?usp=sharing"},
            { titulo:"📚[Slide] Advanced English Suffixes  ",url: "https://drive.google.com/file/d/19QT3eSGDIw0luGzgpbbL_xxn4fSGRWep/view?usp=sharing"},
            { titulo:"📚[Slide] Advanced Structures ",url: "https://drive.google.com/file/d/1GvW9GeD6tA7aIfpaKdPqR13vmpZxQSaN/view?usp=sharing"},
            { titulo:"📚[Slide] As it is / As it were ",url: "https://drive.google.com/file/d/168WIIEOirBRRtLgp6LG3z__dxm87KyTg/view?usp=sharing"},
            { titulo:"📚[Slide] As...As...(phrases) ",url: "https://drive.google.com/file/d/13xHkeweXxT7wrqVkDNvA2lX0PuSKn0S7/view?usp=sharing"},
            { titulo:"📚[Slide] Be up/ Be down phrases ",url: "https://drive.google.com/file/d/1qPG9T5MDNLd01IAi3woFqWyRn9MOc8h4/view?usp=sharing"},
            { titulo:"📚[Slide] Binomials ",url: "https://drive.google.com/file/d/1auzNr8YBvZyU9Fer43Xs0QZbGdYz7ARS/view?usp=sharing"},
            { titulo:"📚[Slide] Causative Verbs : Have and Get ",url: "https://drive.google.com/file/d/1bq9UcnD6RlxoHDfh6FLyQwSIM4AQemMo/view?usp=sharing"},
            { titulo:"📚[Slide] Cause for + Noun ",url: "https://drive.google.com/file/d/1r5GxFXmk3XJkyHWDy93OMdOTR2-XBnBa/view?usp=sharing"},
            { titulo:"📚Chance of-Chance to... ",url: "https://drive.google.com/file/d/18otkt_PTLMwlZGqs4rBnXRMdhz48xUaS/view?usp=sharing"},
            { titulo:"📚CLEFT SENTENCES (TABLE) ",url: "https://drive.google.com/file/d/13-JhSbUYrCntdTi5t097wDYyeUmJH-g1/view?usp=sharing"},
            { titulo:"📚[Slide] Come as a .. to someone",url: "https://drive.google.com/file/d/1Y61w1e4uARR4djO4EsmecXgnDL5tvenx/view?usp=sharing"},
            { titulo:"📚[Slide] Common  C1/C2 Reflexive Pronouns",url: "https://drive.google.com/file/d/1r83pqetQV88Ll3AZmAquQF2sgzKoc-Ta/view?usp=sharing"},
            { titulo:"📚CORRELATIVE CONJUNCTIONS",url: "https://drive.google.com/file/d/16ud5EPb-q127g3tRlHKoV_Pk5HKpLoh8/view?usp=sharing"},
            { titulo:"📚[Slide] Common  Words with silent letters in English ",url: "https://drive.google.com/file/d/1hDcAjjbGpBocnFp8ofSVZ7XgAlaRdPrB/view?usp=sharing"},
            { titulo:"📚[Slide] Conditionals - Advanced Conditionals ",url: "https://drive.google.com/file/d/1qg9Gx8ko88RdqBsU4T15vi6sGFpn08W0/view?usp=sharing"},
            { titulo:"📚JOINING NEGATIVE IDEAS.pdf ",url: "https://drive.google.com/file/d/1OuDSE00YChqB4_W8nCFT7R2DTWt5ZfLF/view?usp=sharing"},
            { titulo:"📚Prevent, Stop, Avoid.",url: "https://drive.google.com/file/d/1FoSc6244qwfBpG9EDxzX7YkHZTuk6EN8/view?usp=sharing"},
            { titulo:"📚Consist in vs Consist of.. ",url: "https://drive.google.com/file/d/1F-XK5pIbsWwlOIDU-XfXpEVATQdlTggq/view?usp=sharing"},
            { titulo:"📚it's a good job.pdf ",url: "https://drive.google.com/file/d/1vHHH_2VXuIdDf_NSp6Ie9FgvHFB94G92/view?usp=sharing"},
            { titulo:"📚immediate future expressions ",url: "https://drive.google.com/file/d/1mOBysPhkjDIvx1ePzrM-LMnlrsGZuOzb/view?usp=sharing"},
            { titulo:"📚57-common-reflexive-verbs-in-english-c1-c2 ",url: "https://drive.google.com/file/d/1ANHJvwOgP9BUAGOUtotZcrOKrIV0-_k8/view?usp=sharing"},
            { titulo:"📚In the (short/medium /long) term / in the (short/long)run ",url: "https://drive.google.com/file/d/1OLnc9y-xWYZeoPXocHl4T0Hlow-W7-Jf/view?usp=sharing"},

           { titulo:"📚[Slide] Conditionals - Conditionals Expressions ",url: "https://drive.google.com/file/d/17HKJ6ZhXNyGbNv9PcDFbQAQxS6fIpIQb/view?usp=sharing"},
           { titulo:"📚[Slide] Conditionals - Mixed Conditionals ",url: "https://drive.google.com/file/d/1K-Rc6kI3OJXSheDjT-EfSP1WYuWh4vts/view?usp=sharing"},

           { titulo:"📚[Slide] Conditionals - If sentences -C1-C2 ",url: "https://drive.google.com/file/d/12unjxwmidN9-_8fowT1cnuosTInLyX-1/view?usp=sharing"},
           { titulo:"📚differentiate, distinguish, discriminate",url: "https://drive.google.com/file/d/1v-uIHL_GseKjuslDEgVGhiTajGCL9CQs/view?usp=sharing"},
           { titulo:"📚[Slide] Would rather/Would Sooner ",url: "https://drive.google.com/file/d/1F-t7qwMfcb5PDKfFodN02qZFwCzIZFqu/view?usp=sharing"},
           { titulo:"📚Expressing lack of surprise (phrases).. ",url: "https://drive.google.com/file/d/10OCN5p9pht9TviKo5C8Tlpq65n7LFSzV/view?usp=sharing"},
           { titulo:"📚Personal and Impersonal Passive",url: "https://drive.google.com/file/d/1obtVtl8UEAVz9UCz4aff_q7WGGYwDim2/view?usp=sharing"},

           { titulo:"📚count on - depend on - rely on",url: "https://drive.google.com/file/d/1DxZyMcb1NwXXbt_wIAbhPTiNFMuvAKG6/view?usp=sharing"},
           { titulo:"📚Direct & Indirect speech (table) + kwt exercises",url: "https://drive.google.com/file/d/1rBQWS8z17BGn4B2mT0SGJt6J5CHEyZkw/view?usp=sharing"},

           { titulo:"📚Universal Tags",url: "https://drive.google.com/file/d/1N2ZdcMbCQ_JEZEgXXsZ7QEjyhjgN2sjY/view?usp=sharing"},
           { titulo:"📚QUESTION TAG - HAVE",url: "https://drive.google.com/file/d/1TfK9qlZtV5D3m1PFQ98IpYTLV8G9RSTM/view?usp=sharing"},
           { titulo:"📚[Slide] The fact that  ",url: "https://drive.google.com/file/d/1FSd3Vt3C71C0kujDoy4egxFDy8_ZugZv/view?usp=sharing"},

        
          
           { titulo:"📚statement tags",url: "https://drive.google.com/file/d/1wPLJc7cxDP6KjIphJKOf5yDgy6PKGqQA/view?usp=sharing"},
           { titulo:"📚SHALL I - QUESTION TAG..",url: "https://drive.google.com/file/d/1mZfz_uoyYNVEG70LhXfZ1SwPfyyIIAi9/view?usp=sharing"},
           { titulo:"📚Question tags -LET’S",url: "https://drive.google.com/file/d/1gIAxg2SqZfz-NawyVGk7kRBm-SGuaL1b/view?usp=sharing"},
           { titulo:"📚Question tags - Double Positives",url: "https://drive.google.com/file/d/15H24JhmJRhfgJRsurnXdLvtyiwgI60LR/view?usp=sharing"},
           { titulo:"📚Question tags - IMPERATIVES..",url: "https://drive.google.com/file/d/1DeYr9sy5FSUJfjyn4xaGHU_Uz78rFwv9/view?usp=sharing"},
           { titulo:"📚it's (about-high) time ",url: "https://drive.google.com/file/d/1JsV99-95VmCWYE-ueZxQOT-2X7G8F-WJ/view?usp=sharing"},
           { titulo:"📚[Slide] Ever to express emphasis ",url: "https://drive.google.com/file/d/1BCSNGtVK8XR0ztmtj9HWuFZKe0i9VE2-/view?usp=sharing"},

           { titulo:"📚THERE ... QUESTION TAG",url: "https://drive.google.com/file/d/1xza1T8UmmTsyM6vSYK6uW-qoVmn5mYKe/view?usp=sharing"},

            { titulo:"📚[Slide] To-infinitive in non-finite relative clauses",url: "https://drive.google.com/file/d/12MXy8BXPHM2bOuUqbZkfld5vmp9ye03t/view?usp=sharing"},
            { titulo:"📚[Slide] To like some or something -Phrases ",url: "https://drive.google.com/file/d/1gOzxiEFLu_IyCAUqaQM3yPJKsFSRFOj9/view?usp=sharing"},
            { titulo:"📚[Slide] To use something to achieve something -Phrases ",url: "https://drive.google.com/file/d/1uACXzYYygl6bmK0mKXsYZ7kgysVD7H2o/view?usp=sharing"},
            { titulo:"📚[Slide] Trinomials ",url: "https://drive.google.com/file/d/1jmROcj7We2J1xV26AwJZfyrwUj0lmjf5/view?usp=sharing"},
            { titulo:"📚Doubt that vs Doubt if",url: "https://drive.google.com/file/d/1qEgnOfM7BoFG1lmMu_xWgNbRlwBTt9X2/view?usp=sharing"},

            { titulo:"📚[Slide] Trust ,Distrust ,Entrust ",url: "https://drive.google.com/file/d/1gC2SLjM0tML-TVWLjl6a4V6wHYYkokbp/view?usp=sharing"},
            { titulo:"📚[Slide] Useful Homophones ",url: "https://drive.google.com/file/d/1MWO2XHuHp0bAzFceREIteP_cKXyuwe1j/view?usp=sharing"},
            { titulo:"📚[Slide] Very + Noun ",url: "https://drive.google.com/file/d/1oiyHIL4pSRBzTwnXmNtl6pPboSqoY76u/view?usp=sharing"},
            { titulo:"📚[Slide] Wait ,Await, Expect ",url: "https://drive.google.com/file/d/1C1llJJ8yFX0i5pxSnTMUWPIjmNvISnHB/view?usp=sharing"},
           
            { titulo:"📚[Slide] Wary vs Weary",url: "https://drive.google.com/file/d/1C8y5Va1PO0FC5UJHWf5HQ4hwBq27lb_y/view?usp=sharing"},
            { titulo:"📚[Slide] What little ,What few ",url: "https://drive.google.com/file/d/1T6khMo1jZdg8ZbNJk1OPBViUBizGTCLo/view?usp=sharing"},
            { titulo:"📚[Slide] When is 'THE' used with superlatives ? ",url: "https://drive.google.com/file/d/1ANoTemvWys1sMGooLBQZyrVaBiWwmk2c/view?usp=sharing"},
            { titulo:"📚[Slide] Will/Would Expressing Willingness and Unwillingness ",url: "https://drive.google.com/file/d/1OSlsIu3un1pwemLHChzkEApSyeaP77ZA/view?usp=sharing"},
            { titulo:"📚[Slide] -wise (suffix) ",url: "https://drive.google.com/file/d/1zzSan5isa6ok5M8b3TXW_Nm8eCcu9Eza/view?usp=sharing"},
            { titulo:"📚[Slide] WITH meaning because of ",url: "https://drive.google.com/file/d/1SGvkOoVIsU6ILExH_eyTHYYodpXDJlLO/view?usp=sharing"},
            { titulo:"📚WHAT and HOW (Exclamations) ",url: "https://drive.google.com/file/d/1OJI6_nCQEgh26dLzcN0Lta-I5Ln202Oq/view?usp=sharing"},
            { titulo:"📚[Slide] To bits(phrases) ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},

            { titulo:"📚[Slide] Summary Grammar : Resumen de Gramática Fundamental para Aprobar  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},

            { titulo:"📚[pdf] First Conditional Grammar  ",url: "https://drive.google.com/file/d/1TtQyZh4nbaFmMEGqPHxpHIx9LhNoWbMh/view?usp=sharing"},
            { titulo:"📚[ppt] Causative Grammar  ",url: "https://docs.google.com/presentation/d/1JqpdJ7rwpjCj7IRuHw8mkN2ZljQxkYbt/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true"},
            { titulo:"📚[pdf] Impersonal/Personal Passive   ",url: "https://drive.google.com/file/d/1ro-Akv2tledwTQjsG984zZsbYmrUhxY9/view?usp=sharing"},
          
            { titulo:"📚[pdf] Direct/Indirect Speech  ",url: "https://drive.google.com/file/d/1uVIQAKwwsRmvlzC9UNvKH3vrKmMak6F6/view?usp=sharing"},
            { titulo:"📚[ppt] Gradable/Non Gradable Adjectives Grammar  ",url: "https://docs.google.com/presentation/d/1rNNytCWmiO5_TVlt-3yANAjAfAiJQn8c4JzC80tZYrg/edit?usp=sharing"},

            { titulo:"📚[ppt] Inversion  ",url: "https://docs.google.com/presentation/d/13x3PsYRJVv5F6oeoVyim8Y7SBSx1udVd/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true"},
            { titulo:"📚[ppt] Inversion Full  ",url: "https://drive.google.com/file/d/1spoUQkw5ZlS6xnDsjni4-k-01SE0ERJW/view?usp=sharing"},
            { titulo:"📚[ppt] Used to/ be used to / get used to   ",url: "https://drive.google.com/file/d/10RJV_9F_2hLn04DslKk5aDae3AdVOa8s/view?usp=sharing"},
            { titulo:"📚[ppt] Whom/whose/Who  ",url: "https://drive.google.com/file/d/1SXlXv80QurkFMcgQ-0PJ0kb8WJOL_Cr9/view?usp=sharing"},
            { titulo:"📚[pdf] Wait/hope/Expect Grammar FunSheet  ",url: "https://drive.google.com/file/d/1d98aBmRU07TtUiQvHhlU2bAklTRQ2iLZ/view?usp=sharing"},

            { titulo:"📚[Slide] Future Continues ",url: "https://drive.google.com/file/d/1L3tzPtKwtGTkRQim2uNsK5iE8tIhnFsT/view?usp=sharing"},
            { titulo:"📚[Slide] Give rise to  / Give way to   ",url: "https://drive.google.com/file/d/1Wo3Ys2A-LbDFO6c2ilwj3_-JI4fG3TN6/view?usp=sharing"},
            { titulo:"📚having a lot to do",url: "https://drive.google.com/file/d/1LiGCvmom_wRtwvNbKXx3WhALIglfBsgS/view?usp=sharing"},
            { titulo:"📚[Slide] Historical Present    ",url: "https://drive.google.com/file/d/1gSil8v-a7EP3k-CU8ob95slVzC2g0JDX/view?usp=sharing"},
            { titulo:"📚[Slide] Hope-Phrases    ",url: "https://drive.google.com/file/d/1ojSQmyHTNt0xMFz4A4_i7-skvREpwR-n/view?usp=sharing"},

            { titulo:"📚[Slide] I wish you didn't / I wish you wouldn't    ",url: "https://drive.google.com/file/d/1jtBHXVvGFjF_v-lYaj7u7Lp7CrNDrmrx/view?usp=sharing"},

            { titulo:"📚If I were vs If I was ",url: "https://drive.google.com/file/d/1L8gL4in7HNGsjw_fqgsCzi2FPNi3VYR8/view?usp=sharing"},


            { titulo:"📚[Slide] Imposing or Transferring responsability  ",url: "https://drive.google.com/file/d/1hNjafS0LbGoS7RqY8EtY6Mf6V6qsoeaY/view?usp=sharing"},
            { titulo:"📚[Slide] Inasmuch as  vs insofar as   ",url: "https://drive.google.com/file/d/15SDhGYZiigaXw1FflTMWP8xC4blDWFNv/view?usp=sharing"},

            { titulo:"📚[Slide] Including or omitting relative pronouns  ",url: "https://drive.google.com/file/d/19D6FgL_bx6H4YftBWYdlB1876M8qabOE/view?usp=sharing"},

            { titulo:"📚[Slide] To + Gerund(Phrases) ",url: "https://drive.google.com/file/d/1-bh7FHVKhKHXYzTNbFhmHLt0AtYlKNC8/view?usp=sharing"},

            { titulo:"📚[Slide] Indeed -How to use this word   ",url: "https://drive.google.com/file/d/1eSjwXx-jlYTML8Usc_KH9uhZ4zJxWUfI/view?usp=sharing"},
            { titulo:"📚[Slide] Phrases with All ",url: "https://drive.google.com/file/d/1mDGMt1JKRa30dj7cnfnknTZikyoxOSiE/view?usp=sharing"},
            { titulo:"📚[Slide] Phrases with Along ",url: "https://drive.google.com/file/d/12KMtH6p9E1hLyx6Oq4ktuhlZ2NsWnBCb/view?usp=sharing"},
            { titulo:"📚[Slide] Phrases with Cases ",url: "https://drive.google.com/file/d/1qjQKqOoDOzasj51JWmxQC6S7-qd_KjLO/view?usp=sharing"},
            { titulo:"📚[Slide] Phrases with Once ",url: "https://drive.google.com/file/d/1oVEUrTm9O9vBv4EkgjuHsp2pe8jPMiQJ/view?usp=sharing"},
            { titulo:"📚[Slide] Phrases with Yet ",url: "https://drive.google.com/file/d/1DQWYOuHyMFqL7X1_zUZ7o9txaZ2fEKc_/view?usp=sharing"},
            { titulo:"📚[Slide] Inversion - Table  ",url: "https://drive.google.com/file/d/14qXwjyRe7Cze827F_YwCASj-9aXev5ZG/view?usp=sharing"},

            { titulo:"📚[Slide] Inversion - Advanced Structures  ",url: "https://drive.google.com/file/d/1aX5Yh67i2LdPWFHCsPRivVGuM5K0EIPs/view?usp=sharing"},
            { titulo:"📚[Slide] Inversion in English -Neither and Nor  ",url: "https://drive.google.com/file/d/1gN81Sppa99dV3iLI9cgRhjmrWQDR9W2o/view?usp=sharing"},
            { titulo:"📚INVERSIONS AT B2 LEVEL..pdf ",url: "https://drive.google.com/file/d/17DCJanovoUIB6Vome6kfXe4kMRVo24Cc/view?usp=sharing"},
            { titulo:"📚[Slide] It as an empty object   ",url: "https://drive.google.com/file/d/1G8Lic6FhxA2q83W09F6Bt5utztkkVSi3/view?usp=sharing"},
            { titulo:"📚[Slide] It comes a time when ....or There comes a time when .. ",url: "https://drive.google.com/file/d/1zaNV-bEQQWZYjKnaDDTputPzUaWFYI5w/view?usp=sharing"},

      

        ],
    },
    {
        id: 5,
        thumbnail:"https://i.ibb.co/DM385Vn/B2-FIRST-15.png",

        title: "Comming Soon ",
        subtitle: "C2",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos conceptos clave de gramática, enfocándonos en la comprensión y aplicación de reglas gramaticales fundamentales para mejorar la precisión y fluidez en el uso del idioma. ",
        enlaces: [
           
          

           
           
           
         
          
            { titulo:"📚[Slide] Not as ...as..., Not so ... as..",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Not so much .../Not...so much as .../Not so much ...as",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] ONLY meaning but or except",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Participle Clauses",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Phrases meaning in Addition ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
           
            { titulo:"📚[Slide] Ponder  vs Pander  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Possessive Gerunds ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Put someone to something - Put something to someone",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Reduce Relative Clauses  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Reduplicatives ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Result in / Result From  ",url: "https://drive.google.com/file/d/1BTmXONrNQGIn9JuG8zngDx0Fck6v2MnW/view?usp=sharing"},
            { titulo:"📚[Slide] Saxon Genitive - Special Cases ",url: "https://drive.google.com/file/d/1hUR9QCWDUMgI2-6ZdNMUKC8DlzjHkYtc/view?usp=sharing"},
            { titulo:"📚[Slide] Singular They",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] So + adjectives +that/ So+ adjectives+as to ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] So much (Phrases)",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] -some(adjective suffix) ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Some to express positive/negative opinion ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Something/A bit/Someone...of a something ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Spoken English -Advanced Phrases ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] STILL meaning despite that ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Subjunctive mood in English",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Tag Questions - Questions Tags :There  ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] Tags - Statement/Reinforcement Tags ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
            { titulo:"📚[Slide] There is no questions (phrases) ",url: "https://drive.google.com/file/d/1D8o4Rz__F5-0ej6rz_gwwJCY9-Ogg_A1/view"},
         
         

        ],
    },
    
    
    {
        id: 13,
        thumbnail:"https://i.ibb.co/NxMbVNf/B2-FIRST-10.png",

        title: "Speaking Center",
        subtitle: "B2/C1",
        color: "#8F2BBC",


        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Aprende a hablar como un hablante nativo enfocándote en la pronunciación, entonación y expresiones idiomáticas para mejorar tu fluidez y naturalidad al hablar.",
        enlaces: [
            {
                titulo: "🖥️[Video] Episodem  Website",
                url: "https://www.youtube.com/watch?v=9dt6WOuoXos",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 01",
                url: "https://drive.google.com/file/d/1QhvhLsCjF6V1BaYqpSd3cV9lgNuOCw_h/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 02",
                url: "https://drive.google.com/file/d/1h-s_T2_bFtZngCACYPMKw4U1V4mB6Ove/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 03",
                url: "https://drive.google.com/file/d/1vm6K2C5j061v2IneytvApO-r9tCdd3KS/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 04",
                url: "https://drive.google.com/file/d/1dGhBsbgRejXuovsdRie-bae23WpeY4V6/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] B2 Speaking Simulation 05",
                url: "https://drive.google.com/file/d/1ItqYXZB6Dc19PdmaB67E-9EZyAyfrl9y/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] Speaking Trainer 01",
                url: "https://drive.google.com/file/d/1n-sf1L6DJZKdj0GSGV2zlPlaYI4WhJQ9/view?usp=sharing",
            },
            {
                titulo: "🖥️[Video] Speaking Trainer 02",
                url: "https://drive.google.com/file/d/1Jiwqspyx05GE1Br1tTir8j-xWm1_-VbG/view?usp=sharing",
            },
            
            {
                titulo: "🎯[Activity] speaking Part 1",
                url: "https://wordwall.net/play/519/287/727",
            },
            {
                titulo: "📒[pdf] Linking Words | B2 First (FCE)",
                url: "https://drive.google.com/file/d/1l7NLEB9G7uwaXkRONIKNJE7BjucKC_pC/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] 10 Preguntas de examen – Speaking Parte 1 (Entrevista) | B2 First (FCE)",
                url: "https://drive.google.com/file/d/1Oe2kqUUQnetTzjYCcia8mx2IrPEurE92/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Explanation",
                url: "https://drive.google.com/file/d/1lQkT1_qz3fPUBqcysqdvxvi6bNtOmXab/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 1 - Useful Phrases",
                url: "https://drive.google.com/file/d/1Fty0C6H85HUHEJBG0KzAAOGK5a6FVMgz/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 2 - Useful Phrases",
                url: "https://drive.google.com/file/d/1vHp3IrV3Wiz1a2m8_GdbdIl3ITc4sf2e/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 3 - Useful Phrases",
                url: "https://drive.google.com/file/d/19HB0czJM2-XZZBuKr3FXHNAn8jP941DF/view?usp=sharing",
            },
            {
                titulo: "📒[pdf] Speaking Part 4 - Useful Phrases",
                url: "https://drive.google.com/file/d/1ZmLmEIS1vnRPbZD9D20vFkEJPpoE9jbm/view?usp=sharing",
            },
            {
                titulo: "📒Mistakes at First ",
                url: "https://drive.google.com/file/d/1GqRFqwYpNz2b52QJIJ9-RIGKOxkEV5HS/view?usp=sharing",
            }
            
            
        ],
    },
   
    {
        id: 19,
        thumbnail:
            "",
        title: "M4 - Relative Clauses I",
        subtitle: "Pre-Intermediate",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Desarrollando habilidades lingüísticas fundamentales",
        enlaces: [
            

            {titulo: "📒[slides] Relative Clauses Explanation",url: "https://drive.google.com/file/d/1cxrD9paWOcm3w7pLDmE_WvAVi2FJQI1x/view?usp=sharing",},
            
            {titulo: "📒[slides] Defining Relative Clauses Exercise 1",url: "https://drive.google.com/file/d/1vLOQ-v7JohxwCcGIeIPZRB0VEIvE1P5b/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 1 key",url: "https://drive.google.com/file/d/1eUbQC4nby3BU4ob6iXnWLBgn1ucZtzGv/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 2",url: "https://drive.google.com/file/d/1zuEnn8IqoyVEFDGtioyJoAaF9beihzmL/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 2 key",url: "https://drive.google.com/file/d/1nAfUnBlJZYD6NAyXyrwcXyEGfEkGNMap/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 3",url: "https://drive.google.com/file/d/1JHS5Kog6HeXhj5GMgKY6GoafIv69Leoj/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 3 key",url: "https://drive.google.com/file/d/1g6Bcda-4oWQ_1ugTLgn-X2l4lAvRbmF2/view?usp=sharing",},

            {titulo: "📒[slides] Defining Relative Clauses Exercise 4",url: "https://drive.google.com/file/d/1_yyKTGRy0f-fcCZ5BlRsMZXsBb2usP3g/view?usp=sharing",},
            {titulo: "🔑 Defining Relative Clauses Exercise 4 key",url: "https://drive.google.com/file/d/1ug8Ybq084KuS4AMXVRJ76pN1rbYs93cA/view?usp=sharing",},
            {titulo: "[Grammar Worksheet] WHO 1 ",url: "https://drive.google.com/file/d/1cFrsL8KTttdqE4BpsR2YGCU2BG_SrfSf/view?usp=sharing",},
            {titulo: "[Grammar Worksheet] WHO 2 ",url: "https://drive.google.com/file/d/1HnZWwulcMoWRBuPlkGff-2xxJ9rX0x56/view?usp=sharing",},

            {titulo: "[Grammar Worksheet] WHOSE",url: "https://drive.google.com/file/d/10p5K6lvpYpdtEIhJNy-redgQ7aLBnVb2/view?usp=sharing",},

            {titulo: "[Grammar Quizz] Relative Clauses",url: "https://drive.google.com/file/d/1DqU2kvUjrAuTRfIzDQkpmleUANeWxnjP/view?usp=sharing",},
            {titulo: "[Grammar Quizz] WHO vs WHOSE",url: "https://drive.google.com/file/d/1Ab3XGgBtb8XhgPRFY-9K91ddlu_cEtpG/view?usp=sharing",},
            {titulo: "RC001 - Relative Clauses",url: "https://drive.google.com/file/d/1K8WkdJTAuJvGBwZcksUylm4xKDiC_efC/view?usp=sharing",},
            {titulo: "RC002 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1OFQyjqF7p2ppuJmqu76GnH3RlL4lkKzM/view?usp=sharing",},
            {titulo: "RC003 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1u24eoljpLI0AB8ROkDi-HSTenUlAubrj/view?usp=sharing",},
            {titulo: "RC004 - Relative Pronouns",url: "https://drive.google.com/file/d/19zQQNKYKQ3j81ooeAS7CLiG8klHE_2Qn/view?usp=sharing",},
            {titulo: "RC005 - Relative Clauses - Combine the TWO Sentences",url: "https://drive.google.com/file/d/1JwHY1cfaESrUMr9Dby2Gt21sxHRtZ5t6/view?usp=sharing",},
           

         
            
            
        ],
    },
   
    
   
    
    {
        id: 15,
        thumbnail:
            "https://i.ibb.co/T2gwBmd/level4.png",
        title: "Writing like Shakespeare",
        subtitle: "B2/C1",

        dateAdded: "B2",
        channel: "sdasd",
        description: "Aprende técnicas literarias avanzadas para enriquecer tu escritura y expresión creativa en inglés",
        enlaces: [
            {
                titulo: "📃[pdf] Essay  B2 Model",
                url: "https://drive.google.com/file/d/1shuKn4-Sgu3VW2SqO1Gbv4a3BNUjFWB0/view?usp=sharing",
            }, {
                titulo: "📃[pdf] Essay  B2 Model 2",
                url: "https://drive.google.com/file/d/1A3zKsg5My6XQlKxWRNiCoM_Jh5Wwepvp/view?usp=sharing",
            }
            ,
            {
                titulo: "📃[pdf] C1 Template Essay 2025",
                url: "https://drive.google.com/file/d/1ELdPTtS6V33-pBtJr2uRSizlrfuCH4nB/view?usp=sharing",
            },
            {
                titulo: "📃[pdf]Useful Language",
                url: "https://drive.google.com/file/d/1gMBSe_vvMgQq-IkIQtpDydmpuKq_YiMa/view?usp=sharing",
            },
            {
                titulo: "📃[pdf] Amazing Template Essay 2025",
                url: "https://drive.google.com/file/d/1GTnhTS-RWFKpJ2Q9DRhBOxb-IqgjIjmZ/view?usp=sharing",
            }
            ,
            {
                titulo: "📃[pdf] Writing Templates",
                url: "https://docs.google.com/document/d/1ynAsrV2Uj-uR0qrCDzGvDw8I2sXYlzEg/edit?rtpof=true&sd=true",
            },
            {
                titulo: "📃[pdf] How to write an Essay",
                url: "https://docs.google.com/presentation/d/1ulmNP0wMeqUi-ZlMpg6ngsCi_jjX9nBn/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true",
            },{
                titulo: "📃[ppt] Advanced Transitions",
                url: "https://docs.google.com/presentation/d/1fGnuhWtExMKny18ZqasLeugnXi9cb9pU/edit?usp=sharing&ouid=114588820780661373500&rtpof=true&sd=true",
            },{
                titulo: "📃[Inf] Writing Mistakes everyone makes",
                url: "https://drive.google.com/file/d/17vYjDTq69ecevpRtiD1mSOevKqFLrOSM/view?usp=sharing",
            },
            
        ],
    },{
        id: 21,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "If-Clauses",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ IF001 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1zkFdLJpLESep41DLgUElfhiyuBzCU_fi/view?usp=sharing", },
            { titulo: "✍ IF002 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1eQ-z-lbU8tKm_BZgrrgJwfkvl2Erbf2c/view?usp=sharing", },
            { titulo: "✍ IF003 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/182p9f-HK7c0eGODpwB3VstwcwQKgmtH7/view?usp=sharing", },
            { titulo: "✍ IF004 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/19z4Pi3T60d7n505lFrt22npAN8bMZG4d/view?usp=sharing", },
            { titulo: "✍ IF005 - IF-Clauses - Missing Sentence Types ",url: "https://drive.google.com/file/d/12FhAI14xsU_5O_Bau-AQFPIQPMwQrIPT/view?usp=sharing", },
            { titulo: "✍ IF006 - IF-Clauses - Missing Sentence Types ",url: "https://drive.google.com/file/d/1FiXA09T66glsOEsLQ6zJv86uzRS5NBAC/view?usp=sharing", },
            { titulo: "✍ IF008 - IF-Clauses - Conditional 1 ",url: "https://drive.google.com/file/d/1frj2F8CUX2wo_ASftPHyFFK037reIw9E/view?usp=sharing", },
            { titulo: "✍ IF009 - IF-Clauses - All Types ",url: "https://drive.google.com/file/d/1dk_3njjacg-x5I-707uoA6ieWhAB8TyU/view?usp=sharing", },
            { titulo: "✍ F010 - IF Clauses - Type 1 ",url: "https://drive.google.com/file/d/1cW9NMcLR6qwyc9TgGIgwcJl41iH9tWMA/view?usp=sharing", },
            { titulo: "✍ IF011 - IF Clauses - Type 2 ",url: "https://drive.google.com/file/d/1H_R3hcWhSwJCTfL____KykDG1pfuyoK5/view?usp=sharing", },
            { titulo: "✍ IF012 - IF Clauses - Type 3 ",url: "https://drive.google.com/file/d/1cG8XOFirGzvJJx7b_Xvv1c1uR38CuBlH/view?usp=sharing", },

            


        ],
    }
    , {
        id: 23,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "Present Perfect Tense",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1D0VK7vPjtlAMOc8WqxQUQn62_F3-uJsa/view?usp=sharing", },            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1GWFlQ8RvPK7qb3S8HLBhKTlBONeogy0H/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1jgcxBuSKBZ6LdIQbWXL3_4lJDv4D8QVa/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1jvFbc4GPFUHXIgx0gmbgslQQz7KmIMG0/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1iCSWPTOFu1vGbkEaW6xSPh-Z_-koKr3V/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1uik-f0MFXujPMnbgmOiCIegxSmWAI5qI/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1CyruZuJFKhWpzmNmFQ9H9oigRjqgY0ui/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/1i-A68Tl92LNR87MyIWPPTEceTrIlU_hw/view?usp=sharing", },
            { titulo: "✍ Present Perfect Simple and Progressive ",url: "https://drive.google.com/file/d/11Jj4BydUErvqumFiFy5goX5pGQkZq9HY/view?usp=sharing", },

            
        ],
    }, {
        id: 26,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "Future Tenses",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Ways of Expressing Future Tense ",url: "https://drive.google.com/file/d/1J6r3JFYzr-U4CzRQihyMcl6uB2Ms7bu0/view?usp=sharing", },    
            { titulo: "✍  Future Tenses ",url: "https://drive.google.com/file/d/1uQEVuavBgrytYsOTlD3dAg8qZDCtZEa_/view?usp=sharing", },
            
           

            
        ],
    },
    {
        id: 26,
        thumbnail:
            "https://i.ibb.co/W2FY74b/level5.png",
        title: "TOEFL - Grammar",
        subtitle: "B2/C1",

        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo: "✍ Modal Verbs ",url: "https://drive.google.com/file/d/1Nblkea4-3PmGpg_cOHpi9NXn_HRNGj_V/view?usp=sharing", },    
            
            { titulo: "✍ Comparatives & Modifiers  ",url: "https://drive.google.com/file/d/1Nblkea4-3PmGpg_cOHpi9NXn_HRNGj_V/view?usp=sharing", },    
            { titulo: "✍ Comparatives & Modifiers II  ",url: "https://drive.google.com/file/d/1XFgGX1sdYUdhvYpKfK4e_Cqj_mQOie3-/view?usp=sharing", },    
            { titulo: "✍ Comparatives & Modifiers III  ",url: "https://drive.google.com/file/d/1RdfYJnYLdMF7j3sS-hKJesOMGmqmdXP3/view?usp=sharing", },    
            { titulo: "✍ Connectors  ",url: "https://drive.google.com/file/d/1RdfYJnYLdMF7j3sS-hKJesOMGmqmdXP3/view?usp=sharing", },    
            { titulo: "✍ Correct Sentence Multiple Choice  ",url: "https://drive.google.com/file/d/1fDfIVqWLrLhqVHo-U1WMzsYqzgQ8M1Tr/view?usp=sharing", },    

            { titulo: "✍ Parallel Structures ",url: "https://drive.google.com/file/d/1pTDJGKjUyVQSG6tEne2HdTIcdu96LDuE/view?usp=sharing", },    

            { titulo: "✍Word Choice 1  ",url: "https://drive.google.com/file/d/1QBCWjTJ69eYmnp5LjxD32_sHESeUf2PT/view?usp=sharing", },    
            { titulo: "✍Word Choice 2  ",url: "https://drive.google.com/file/d/11AcnwZ85R7GsoaU0kGKzYwV7wAzadRQ0/view?usp=sharing", },    
            { titulo: "✍Word Choice 3  ",url: "https://drive.google.com/file/d/1mYW1BkrSOc_JDU0e-bH2w6-S5MwBg6LV/view?usp=sharing", },    
            { titulo: "✍Word Choice 4  ",url: "https://drive.google.com/file/d/15BawZ93O21V7AC3mR_4sW29hzftMdMNd/view?usp=sharing", },    
            { titulo: "✍Noun Phrases ",url: "https://drive.google.com/file/d/16oHUr1WoZ8h3OuKA3J_i7h_4-yrDMWpy/view?usp=sharing", },    
            { titulo: "✍Noun Phrases 2 ",url: "https://drive.google.com/file/d/1YHlLWaR-D7oOGE7nsit_ciUJOyhGg__u/view?usp=sharing", },    
            { titulo: "✍Verbs & Tenses ",url: "https://drive.google.com/file/d/1maGomb9hSFctNQciK0iQ65MS6NcBmyB9/view?usp=sharing", },    
            { titulo: "✍Verbs & Tenses 2 ",url: "https://drive.google.com/file/d/1hmNX83_c71spUojY26NX0Lr1xu8lFatr/view?usp=sharing", },    
            { titulo: "✍Negative Word Choice  ",url: "https://drive.google.com/file/d/1EIhDVNF1zmA3aHY5GWLMlY8yFfU0YvsJ/view?usp=sharing", },    
            
            { titulo: "✍ Pronouns Multiple Choice  ",url: "https://drive.google.com/file/d/1NW1tqZPEhz_x-C3R_JkIxlPI2AEpo2Ip/view?usp=sharing", },    
            { titulo: "✍Prepositions 1 ",url: "https://drive.google.com/file/d/1zBC_Z2Yx-v6snlVv04J7f3phtsltg9ZJ/view?usp=sharing", },    
            { titulo: "✍Prepositions 2 ",url: "https://drive.google.com/file/d/1RmqHsasdx0v9YIwCH5-kQkgYl8N-PtFB/view?usp=sharing", },    
            { titulo: "✍Much or Many Exercise  ",url: "https://drive.google.com/file/d/1RCGY76NB6Sw920zvaJ5XDSdHxFv3VrCh/view?usp=sharing", },    
            { titulo: "✍ Some or Many Exercise  ",url: "https://drive.google.com/file/d/1FnvjpGc0aO_CYRW4X029MTHsiXeSc4nu/view?usp=sharing", },    
            { titulo: "✍ Last or Latter Exercise  ",url: "https://drive.google.com/file/d/1cg_ddekwaAS49iRAbDxV0CiJlM3Y9o0R/view?usp=sharing", },    
            { titulo: "✍ Superlatives  Exercise  ",url: "https://drive.google.com/file/d/1MfGGvdY2UGYMWWYg4y6pMWx6x9ijW85J/view?usp=sharing", },    
            { titulo: "✍ Past Tense  Exercise  ",url: "https://drive.google.com/file/d/1xqAs1XF73eyqoH7hnyCpg_9QobkecHca/view?usp=sharing", },    
            { titulo: "✍ Conditional Matching Exercise ",url: "https://drive.google.com/file/d/1pceZifEmXB5sk-AmhG4GqP00Tj63rFVA/view?usp=sharing", },    

            { titulo: "✍ Gerund or Infinitive Exercise  ",url: "https://drive.google.com/file/d/1FAsG76_HqxXJIftk59cJIuM-wbXupH93/view?usp=sharing", },    

        ],
    }
];
